<template lang="pug">
    .table__body
        TableBlock( :data="data" :isUpdate="isUpdate" :info="info")
</template>

<script>
import TableBlock from '../components/TableBlock';

export default {
  components: { TableBlock },
  props: ['data', 'isUpdate', 'info']
};
</script>
